import Loadable from 'react-loadable';

const LazyAddPeopleDialog = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_invite-people-dialog" */ './main'
		),
	loading: () => null,
});
LazyAddPeopleDialog.displayName = 'lazy(AddPeopleDialog)';

export default LazyAddPeopleDialog;
